import TagManager from 'react-gtm-module';

const REGISTRATION_TYPE_KEY = 'pl-gtm-reg-type';

export const buildUserParams = user => ({
    first_name: user?.firstName ?? '',
    last_name: user?.lastName ?? '',
    email: user?.email ?? '',
    phone: user?.phoneNumber ?? '',
    language: user?.language ?? '',
    user_id: user?.id ?? '',
    account_id: user?.accountId ?? '',
});

class GTManager {
    init() {
        const tagManagerArgs = {
            gtmId: 'GTM-TBDTXC6',
        };

        if (import.meta.env.REACT_APP_STAGE === 'prod') {
            TagManager.initialize(tagManagerArgs);
        }
    }

    update(data) {
        const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
        const mergedUser = {
            ...userFromLocalStorage,
            ...data,
            token: data.token || userFromLocalStorage?.token,
        };
        localStorage.setItem('user', JSON.stringify(mergedUser));
        this.push('user-data-updated', buildUserParams(mergedUser));
    }

    setRegistrationType(type) {
        localStorage.setItem(REGISTRATION_TYPE_KEY, type);
    }

    getRegistrationType() {
        return localStorage.getItem(REGISTRATION_TYPE_KEY) ?? '';
    }

    clearRegistrationType() {
        localStorage.removeItem(REGISTRATION_TYPE_KEY);
    }

    push(event, params = {}) {
        window.dataLayer?.push({ event, ...params });
    }
}

export default new GTManager();
